import React from 'react';
import LogoImage from './img/logo-transparent.png'; 
import LogoText from './img/LogoTextNew.png'; 

const Logo = ({ sizeLogo, sizeText }) => {
  return (
    <div>
      <img src={LogoImage} alt="Logo" width={sizeLogo} height={sizeLogo} />
      <img src={LogoText} alt="LogoText" width={sizeText} height={sizeText / 4} className='logoText' />
    </div>
  );
};

export default Logo;